<template>
  <div class="md-layout md-alignment-top-center md-gutter">
    <div class="md-layout-item md-size-45">
      <button class="btn btn-outline-dark btn-lg btn-block" @click="back">{{backBtnTitle}}</button>
    </div>
    <div class="md-layout-item md-size-45">
      <button class="btn btn-primary btn-lg btn-block" @click="next">{{nextBtnTitle}}</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ButtonBar',
    props: {
      backBtnTitle: {
        type: String,
        default: '戻る',
      },
      nextBtnTitle: {
        type: String,
        default: '次へ',
      },
    },
    methods: {
      back() {
        this.$emit('back');
      },
      next() {
        this.$emit('next');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/parts/ButtonBar.vue?6f4fae43